import { Box, Drawer, DialogTitle, ModalClose, Stack } from '@mui/joy';
import { useMediaQuery, useTheme } from '@mui/material';

// Right-hand drawer with a fixed title row, a scrolling body and a footer that
// stays pinned to the bottom. Used by the filter drawers and by bulk edit.
// On mobile it slides up from the bottom instead, since a right-hand sheet
// on a narrow screen leaves no room to swipe or reach the close button.
export function SideDrawer({ open, onClose, title, gap = 2.5, backgroundColor = 'white', footer, children }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Drawer
      open={open}
      onClose={onClose}
      anchor={isMobile ? 'bottom' : 'right'}
      slotProps={{ content: { sx: {
        width: { xs: '100%', sm: 400 },
        height: { xs: '100dvh', sm: '100%' },
        backgroundColor: backgroundColor === 'gray' ? 'var(--joy-palette-neutral-100)' : '#fff',
      } } }}
    >
      <Box sx={{ p: 2, pb: 1.5, borderBottom: '1px solid var(--joy-palette-divider)' }}>
        <DialogTitle>{title}</DialogTitle>
        <ModalClose />
      </Box>
      <Stack gap={gap} sx={{ p: 2, pt: 2, flex: 1, overflowY: 'auto' }}>
        {children}
      </Stack>
      {footer && (
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          gap={2}
          sx={{ p: 2, pt: 1.5, borderTop: '1px solid var(--joy-palette-divider)' }}
        >
          {footer}
        </Stack>
      )}
    </Drawer>
  );
}
